/**
 * @Description: 素材功能栏组件提取
 * @author zhaijiayu
 * @date 2021/8/30
*/
<template>
  <span class="material-action-bar">
    <span class="vertical-bar" v-if="vertical">
      <el-dropdown @command="handleCommand" trigger="click">
        <span style="cursor: pointer">
          <i class="el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="show">查看</el-dropdown-item>
          <el-dropdown-item command="delete" v-show="materialDetail.is_my"
            >删除</el-dropdown-item
          >
          <el-dropdown-item
            command="download"
            v-if="parseInt(materialDetail.cm_check) === 2"
            >下载</el-dropdown-item
          >
          <el-dropdown-item
            command="use"
            v-if="materialDetail.cm_type == 2 || materialDetail.cm_type == 3"
            >使用</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </span>
    <span class="horizontal-bar" v-else>
      <el-popconfirm
        v-show="materialDetail.is_my"
        title="确认删除该条素材？"
        @confirm="handleDeleteMaterial(materialDetail.cm_id)"
      >
        <el-button type="text" slot="reference">删除</el-button>
      </el-popconfirm>
      <span v-if="parseInt(materialDetail.cm_check) === 2" class="func-bar">
        <el-button
          type="text"
          @click="updateMaterialOperation(materialDetail.cm_id, 3)"
        >
          <span @click="download(materialDetail.cm_url)">下载</span>
        </el-button>
        <!--    todo: 需要h5接入-->
        <!--    <el-button type="text" @click="updateMaterialOperation(materialDetail.cm_id, 5)">分享</el-button>-->
        <el-button
          type="text"
          @click="handleUse(materialDetail.cm_id, materialDetail.cm_type)"
          v-if="materialDetail.cm_type == 2 || materialDetail.cm_type == 3"
          >使用</el-button
        >
      </span>
    </span>

    <script-type-selector
      :show="showSelector"
      :cancel-select="() => (showSelector = false)"
      :finish-select="gotoWrite"
      :material-type="useMaterialType"
    />

    <el-dialog
      title="请完成实名认证"
      :visible.sync="certificationVisible"
      class="certificationInfoContainer"
      width="1026px"
    >
      <p class="title">
        应网络实名制要求，完成实名认证后才可以发表文章视频等内容，以保护账号安全。
      </p>
      <div class="borderContainer">
        <div>
          <p class="infoTitle">1、打开“顶端新闻”App</p>
          <p class="info">登录当前账号或扫下方二维码下载“顶端新闻”App</p>
          <img
            src="../../../assets/85d81507ebe84f210b224bf8e02c6d76966336a7fff89e02e5f088ed492cce1f.png"
            class="qrCode"
          />
        </div>
        <div>
          <p class="infoTitle">2、打开“我的”</p>
          <p class="info">点击“实名认证”完成实名认证</p>
          <img
            src="../../../assets/shiming@2x.png"
            class="app"
            v-if="u_cert != 1"
          />
          <img src="../../../assets/shenqing@2x.png" class="app" v-else />
        </div>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { RESOURCE_HOST } from "../../../constants/apiHosts";
import typeSelector from "../../../components/script-type-selector.vue";

export default {
  name: "action-bar",
  components: {
    ScriptTypeSelector: typeSelector,
  },
  props: {
    materialDetail: Object,
    refreshList: Function,
    vertical: {
      default: false,
    },
  },
  data: function () {
    return {
      showSelector: false,
      useMaterialId: "",
      useMaterialType: "",
      u_cert: 0,
      u_cert_status: 0,
      certificationVisible: false,
    };
  },
  created() {
    this.u_cert_status = localStorage.getItem("u_cert_status");
    this.u_cert = localStorage.getItem("u_cert");

    setTimeout(() => {
      this.u_cert_status = localStorage.getItem("u_cert_status");
      this.u_cert = localStorage.getItem("u_cert");
    }, 3000);
  },
  methods: {
    /**
     * 垂直功能栏控制器
     * @param command 调用的命令
     */
    handleCommand: function (command) {
      switch (command) {
        case "show":
          this.gotoDetail(this.materialDetail.cm_id);
          return;
        case "delete": {
          this.$confirm("确认删除该素材", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.handleDeleteMaterial(this.materialDetail.cm_id);
            })
            .catch();
          break;
        }
        case "download":
          this.download(this.materialDetail.cm_url);
          return;
        case "use":
          this.handleUse(
            this.materialDetail.cm_id,
            this.materialDetail.cm_type
          );
          return;
        default:
          return;
      }
    },
    /**
     * 跳转素材详情
     * @param id 素材id
     */
    gotoDetail: function (id) {
      window.open(
        this.$router.resolve({
          name: "materialDetail",
          query: { materialId: id },
        }).href,
        "_blank"
      );
    },
    /**
     * 删除按钮
     * @param materialId {number} 素材id
     * @returns {Promise<void>}
     */
    handleDeleteMaterial: async function (materialId) {
      try {
        await this.$axios(`${RESOURCE_HOST}/api/material/delChild`, {
          method: "POST",
          data: {
            ids: materialId,
          },
        });
        this.$message.success("删除素材成功");
        this.refreshList && this.refreshList(true);
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * 更新素材的操作状态
     * @param materialId 素材id
     * @param behaviorId 行为id 3-下载 5-分享
     */
    updateMaterialOperation: async function (materialId, behaviorId) {
      try {
        await this.$axios(`${RESOURCE_HOST}/api/material/operation`, {
          method: "post",
          data: {
            cm_id: materialId,
            cml_behavior: behaviorId,
          },
        });
        this.refreshList && (await this.refreshList());
        this.$message.success("素材操作成功");
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * 下载视频
     * @param url 视频资源链接
     */
    download: function (url) {
      let xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob"; // 返回类型blob
      xhr.onload = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          let blob = this.response;
          // 转换一个blob链接
          let u = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.download = name;
          a.href = u;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
      };
      xhr.send();
    },
    /**
     * 打开稿件类型选择框
     * @param id
     * @param materialType 素菜类型
     */
    handleUse: function (id, materialType) {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      this.useMaterialId = id;
      this.useMaterialType = materialType + "";
      this.showSelector = true;
    },
    /**
     * 跳转写稿页
     * @param type 稿件类型
     */
    gotoWrite: function (type) {
      type = parseInt(type);
      this.showSelector = false;
      switch (type) {
        case 1: {
          console.log(this.useMaterialId);

          //写稿
          let routeData = this.$router.resolve({
            path: "/scriptWrite",
            query: { materialId: this.useMaterialId },
          });
          window.open(routeData.href, "_blank");
          break;
        }

        case 2: {
          //视频的跳转，加上了id
          let routeData = this.$router.resolve({
            path: "/videoWrite",
            query: { materialId: this.useMaterialId },
          });
          window.open(routeData.href, "_blank");
          break;
        }

        case 3: {
          //图集
          let routeData = this.$router.resolve({
            path: "/graphWrite",
            query: { materialId: this.useMaterialId },
          });
          window.open(routeData.href, "_blank");
          break;
        }
        default:
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.material-action-bar {
  .func-bar {
  }
}

.certificationInfoContainer {
  /deep/.el-dialog__header {
    padding: 20px 32px;

    .el-dialog__title {
      font-size: 16px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #333333;
      line-height: 22px;
    }
  }

  /deep/.el-dialog__body {
    padding: 10px 32px 41px 32px;

    .title {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-bottom: 20px;
    }

    .borderContainer {
      height: 255px;
      border-radius: 6px;
      border: 1px solid #dcdfe6;
      display: flex;
      padding: 28px 32px 0 32px;
      justify-content: space-between;

      div {
        flex: 1;

        .infoTitle {
          font-size: 16px;
          font-family: PingFang-SC-Heavy, PingFang-SC;
          font-weight: 800;
          color: #333333;
          line-height: 22px;
          margin-bottom: 10px;
        }

        .info {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }

        .qrCode {
          width: 118px;
          margin: 22px 0 0 117px;
        }

        .app {
          width: 198px;
          margin: 20px 0 0 43px;
        }
      }
    }
  }
}
</style>